import type { Cart } from '@/modules/cart/domain/Cart';
import {
  containsEasyProduct,
  containsIntangible
} from '@/modules/perseo-billing/components/accordion';
import { PAYMENT_METHODS } from '@/modules/perseo-billing/constants/src/providers/payment-methods';
import type { IPaymentMethodResponse } from '@/modules/perseo-billing/interfaces';

import {
  CardIcon,
  CencoPayIcon,
  CencoPayIconDisabled,
  CencosudIcon,
  ClubIcon,
  ClubIconDisabled,
  GiftCardIcon,
  GiftCardIconDisabled,
  WebPayIcon
} from '../../payment-methods-header/icons';

const paymentMethodsIcons = {
  [PAYMENT_METHODS.EPAY_CENCOSUD_TCOM]: <CencosudIcon />,
  [PAYMENT_METHODS.EPAY_TCOM]: <CardIcon />,
  [PAYMENT_METHODS.WEBPAY]: <WebPayIcon />,
  [PAYMENT_METHODS.GIFT_CARD]: <GiftCardIcon />,
  [PAYMENT_METHODS.CENCOPAY]: <CencoPayIcon />,
  [PAYMENT_METHODS.CLUB]: <ClubIcon />
};

const disabledPaymentMethodsIcons = {
  [PAYMENT_METHODS.CENCOPAY]: <CencoPayIconDisabled />,
  [PAYMENT_METHODS.CLUB]: <ClubIconDisabled />,
  [PAYMENT_METHODS.GIFT_CARD]: <GiftCardIconDisabled />
};

const getPaymentMethodIcon = (id: string, disabled: boolean) => {
  return disabled
    ? disabledPaymentMethodsIcons[id] || null
    : paymentMethodsIcons[id] || null;
};

const getPaymentMethodSubtitle = (
  paymentMethod: IPaymentMethodResponse,
  isActive: boolean,
  cart?: Partial<Cart> & { isEasyMarketplaceEnabled?: boolean }
) => {
  if (isActive) return paymentMethod.subTitle;

  const isGiftCardMethod = paymentMethod.methodId === PAYMENT_METHODS.GIFT_CARD;
  const isCencoPayMethod = paymentMethod.methodId === PAYMENT_METHODS.CENCOPAY;
  const isEasyMarketplaceEnabled = cart?.isEasyMarketplaceEnabled;

  if (isGiftCardMethod) {
    const hasInvoice = cart?.billingAddress?.isInvoice;
    if (hasInvoice) {
      return 'No disponible con factura';
    }
    if (cart) {
      const hasIntangible = containsIntangible(cart);
      if (hasIntangible) {
        return 'No disponible para servicios o productos Easy.';
      }
    }
  }
  if (cart && isCencoPayMethod) {
    const hasEasyProduct = containsEasyProduct(cart);

    if (hasEasyProduct && !isEasyMarketplaceEnabled) {
      return 'No disponible para servicios o productos Easy.';
    }
  }

  return paymentMethod.subTitle;
};

export { getPaymentMethodIcon, getPaymentMethodSubtitle };
